import { Switch } from '@thanx/uikit/switch'
import ImagePicker from 'components/ImagePicker'
import React from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { selectAppHomePageValidation } from 'selectors/validation'
import { ContentBlockData } from 'slices/appLandingPageTheme/types'
import FormsyBrameCampaignSelector from './FormsyBrameCampaignSelector'

type Props = {
  blockId: string
  contentBlock: ContentBlockData
}

const GameContent = ({ blockId, contentBlock }: Props) => {
  const imageValidation = useSelector(selectAppHomePageValidation)

  if (!imageValidation) return <></>
  if (contentBlock.type !== 'game') return <></>

  const rawCampaignId = contentBlock.settings?.brame_campaign_id

  const brame_campaign_id: number | undefined = rawCampaignId
    ? Number(rawCampaignId)
    : undefined

  return (
    <>
      <Switch condition={'image' in contentBlock}>
        <ImagePicker
          className="mb-l"
          name={`${blockId}.image`}
          value={contentBlock.image}
          imageValidations={imageValidation}
          validations={{
            image: true,
          }}
          validationErrors={{
            image: I18n.t('validations.is_required'),
          }}
        />
      </Switch>

      <FormsyBrameCampaignSelector
        name={`${blockId}.settings.brame_campaign_id`}
        value={brame_campaign_id}
        validations={{
          isRequired: true,
        }}
        validationErrors={{
          isRequired: I18n.t('validations.is_required'),
        }}
      />
    </>
  )
}

export default GameContent
